// src/pages/OrderEntry.jsx
// Page wrapper for Order Entry

import React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth0 } from '@auth0/auth0-react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import OrderEntry from '../components/OrderEntry/OrderEntry.jsx';

export default function OrderEntryPage() {
  const { user, isLoading, error } = useAuth0();
  const location = useLocation();

  const initialCompany = React.useMemo(() => {
    const params = new URLSearchParams(location.search || '');
    const next = String(params.get('company') || '')
      .trim()
      .toLowerCase();
    return next === 'tms' ? 'tms' : 'tzi';
  }, [location.search]);

  React.useEffect(() => {
    document.title = 'Order Entry';
  }, []);

  if (isLoading) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography>Loading user…</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">Error loading user information.</Typography>
      </Box>
    );
  }

  if (!user || !user.email) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography color="error">User not authenticated or missing email.</Typography>
      </Box>
    );
  }

  const userEmail = user.email;

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Order Entry
      </Typography>

      <Typography variant="subtitle1" sx={{ mb: 3 }}>
        Logged in as: <strong>{userEmail}</strong>
      </Typography>

      <OrderEntry
        key={`order-entry-${initialCompany}`}
        userEmail={userEmail}
        initialCompany={initialCompany}
      />
    </Box>
  );
}
